import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { UserService } from '../services/user.service';
import { Utility } from '../entities/utils';

@Component({
  selector: 'app-company-dropdown',
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, MatInputModule, ReactiveFormsModule, FormsModule],
  templateUrl: './company-dropdown.component.html',
  styleUrl: './company-dropdown.component.scss'
})
export class CompanyDropdownComponent implements OnInit {
  companies = new FormControl('');
  companyList: any;
  showdropDown: boolean = false;
  storageCompyValue: any;
  userRoleList = ["COMPANY_ADMIN", "PORTAL_ADMIN"];
  @Output()
  companySelection: EventEmitter<{ companyList: any[] }> = new EventEmitter();
  constructor(private userServicec: UserService) {

  }
  ngOnInit(): void {
    let userRoleCurrent = localStorage.getItem("role");
    if (userRoleCurrent) {
      if (this.userRoleList.includes(userRoleCurrent)) {
        this.showdropDown = true;
      } else {
        this.showdropDown = false;
      }
    }

    this.userServicec.getcompanyList().subscribe((res: any) => {
      this.companyList = res;
    })
    this.storageCompyValue = Utility.getCompanySelected();
    if (this.storageCompyValue) {
      this.companies = this.storageCompyValue;
    }
  }

  foo(event: any) {

    Utility.setCompanySelected([]);
    let companyIdList: any = []
    let emitedcompanyList: any = []
    Utility.setCompanySelected(this.companies.value);
    companyIdList.push(this.companies.value);
    companyIdList.forEach((element: any) => {
      element.forEach((cmpID: any) => {
        emitedcompanyList.push(cmpID._id
        )
      });
    });

    this.companySelection.emit({ companyList: emitedcompanyList });
  }


}
